import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantContextService } from './tenant-context.service';
import { environment } from '../../environments/environment';


//TODO: MOŽDA NAM NE TREBA, kao ni tenant context service

export const TenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenant = inject(TenantContextService).getTenantId();
  
  const headersToSet: Record<string, string> = {};
  if (!req.headers.has('X-Tenant-ID')) {
    headersToSet['X-Tenant-ID'] = tenant;
  }

  if (Object.keys(headersToSet).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders: headersToSet }));
};
